module.exports = __webpack_public_path__ + "img/tradingproductCommodity.dd9f7bfc.png";